import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="w-full bg-background-900 text-background-200">
      <div className="max-w-6xl mx-auto px-6 md:px-10 py-14 md:py-18">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <span className="font-heading text-xl font-bold text-white tracking-tight">
              Basetao<span className="text-primary-400">Sheet</span>
            </span>
            <p className="text-xs md:text-sm text-background-400 mt-3 leading-relaxed">
              The ultimate resource hub for Basetao Spreadsheet guides, product finds, reviews, and shopping tips.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">Quick Links</h4>
            <div className="flex flex-col gap-2.5">
              <a href="#categories" className="text-xs md:text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">Categories</a>
              <a href="#what-is" className="text-xs md:text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">About</a>
              <a href="#reviews" className="text-xs md:text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">Reviews</a>
              <a href="#safety" className="text-xs md:text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">Safety</a>
              <Link to="/basetao-spreadsheet-ultimate-guide" className="text-xs md:text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">Ultimate Guide</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">Popular Categories</h4>
            <div className="flex flex-col gap-2.5">
              {categories.slice(0, 6).map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-xs md:text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">Resources</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/basetao-spreadsheet-ultimate-guide" className="text-xs md:text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">Complete Guide</Link>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs md:text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">Main Website</a>
              <span className="text-xs md:text-sm text-background-400 whitespace-nowrap">2026 Updated</span>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; 2026 basetaosheet.link &mdash; Educational resource. Not affiliated with Basetao.
          </p>
          <div className="flex items-center gap-6">
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-background-500 hover:text-primary-400 transition-colors whitespace-nowrap">Main Site</a>
            <Link to="/basetao-spreadsheet-ultimate-guide" className="text-xs text-background-500 hover:text-primary-400 transition-colors whitespace-nowrap">Guide</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}